var _rect, _path, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _path8, _polygon2, _path9, _polygon3, _path10, _circle, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChoice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 729,
    height: 658,
    viewBox: "0 0 729 658",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 93,
    width: 298,
    height: 168,
    fill: "#6c63ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M535.31443,392.74227h-300v-170h300Zm-298-2h296v-166h-296Z",
    transform: "translate(-215.31443 -146.74227)",
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 409,
    y: 17,
    width: 298,
    height: 168,
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M944.31443,316.74227h-300v-170h300Zm-298-2h296v-166h-296Z",
    transform: "translate(-215.31443 -146.74227)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M727.42861,804.74227h-381a1,1,0,1,1,0-2h381a1,1,0,1,1,0,2Z",
    transform: "translate(-215.31443 -146.74227)",
    fill: "#ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M584.94579,568.47455A12.38034,12.38034,0,0,1,600.06091,556.989l16.372-23.07272,16.44782,6.5295-23.57812,32.25841a12.44744,12.44744,0,0,1-24.35686-4.22968Z",
    transform: "translate(-215.31443 -146.74227)",
    fill: "#a0616a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M602.90561,548.632l29.109-48.95706L620.155,468.04947l16.15228-43.07395.59568.25555c.39058.16734,9.56836,4.26281,10.92858,18.92951l18.56189,58.33693-49.53915,64.26717Z",
    transform: "translate(-215.31443 -146.74227)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M444.813,368.65055a12.3803,12.3803,0,0,1,10.28248,15.9579l21.73782,18.10693-7.78163,15.89375-30.33887-26.00164a12.44745,12.44745,0,0,1,6.1002-23.95694Z",
    transform: "translate(-215.31443 -146.74227)",
    fill: "#a0616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M463.2075,388.09077l46.55991,32.807,32.44778-9.37889,41.69617,19.43425-.30084.57414c-.197.37647-4.98984,9.21014-19.7178,9.43231l-59.59745,13.99592-60.2446-54.35977Z",
    transform: "translate(-215.31443 -146.74227)",
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "333.089 640.297 316.903 640.297 309.202 577.863 333.092 577.864 333.089 640.297",
    fill: "#a0616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M300.57258,635.67157h35.985a0,0,0,0,1,0,0v19.655a0,0,0,0,1,0,0H285.68572a0,0,0,0,1,0,0v-4.76818A14.88686,14.88686,0,0,1,300.57258,635.67157Z",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "397.784 640.297 381.597 640.297 373.897 577.863 397.786 577.864 397.784 640.297",
    fill: "#a0616a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M365.26694,635.67157h35.985a0,0,0,0,1,0,0v19.655a0,0,0,0,1,0,0H350.38008a0,0,0,0,1,0,0v-4.76818A14.88686,14.88686,0,0,1,365.26694,635.67157Z",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "403.54 412.407 402.22 504.828 400.9 626.295 371.853 623.654 357.33 455.977 338.846 623.654 308.859 623.654 305.839 454.657 316.401 417.688 403.54 412.407",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M528.82027,564.99455l-4.425-.19151L544.949,451.57579l-8.41566-34.22331a7.48958,7.48958,0,0,1,4.6419-8.79869l15.14186-5.6777,5.34935-14.71141,42.20641,4.548L604.91075,404.21c4.57364,1.46685,42.23691,14.01,39.63821,28.30213-2.56488,14.10666-17.70915,58.48857-18.47822,60.73778l-2.65217,63.64914-.32624.16311c-.39269.19635-29.48413,14.50056-61.08849,14.49815C550.87438,571.55973,539.42684,569.78477,528.82027,564.99455Z",
    transform: "translate(-215.31443 -146.74227)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 581.11565,
    cy: 350.49552,
    r: 30.38881,
    transform: "translate(-220.48051 545.53717) rotate(-61.33681)",
    fill: "#a0616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M605.73047,379.91276c-5.79138,6.16906-16.54677,2.85737-17.30139-5.57045a10.18165,10.18165,0,0,1,.01281-1.96632c.38963-3.73316,2.54637-7.12242,2.02975-11.06411a5.80213,5.80213,0,0,0-1.06186-2.71612c-4.615-6.17988-15.44834,2.7641-19.80382-2.83036-2.67068-3.43039.46868-8.83137-1.58076-12.66542-2.70493-5.06032-10.71679-2.56405-15.74108-5.33533-5.59013-3.08338-5.25578-11.66024-1.576-16.87713,4.48768-6.36221,12.356-9.75708,20.12633-10.24635s15.48707,1.61122,22.74136,4.4383c8.24232,3.21213,16.41577,7.65133,21.488,14.89884,6.16835,8.81374,6.762,20.663,3.67705,30.969C616.86429,367.21654,610.45975,374.87506,605.73047,379.91276Z",
    transform: "translate(-215.31443 -146.74227)",
    fill: "#2f2e41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoice);
export default __webpack_public_path__ + "static/media/choice.2cee714260a3accb8baeafa39faf1a53.svg";
export { ForwardRef as ReactComponent };